import * as S from './Page.style';

export type PageProps = React.ComponentProps<typeof S.PageContainer> & {
  header?: React.ReactNode;
  children: React.ReactNode;
  footer?: React.ReactNode;
};

export function Page({
  children,
  $backgroundColor,
  header,
  footer,
  ...containerProps
}: PageProps) {
  return (
    <S.PageContainer $backgroundColor={$backgroundColor} {...containerProps}>
      {header}

      <S.Content>{children}</S.Content>

      {footer}
    </S.PageContainer>
  );
}
